var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('section',{staticClass:"wrapper scrollable"},[_c('section',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_c('div',[_c('img',{attrs:{"src":"/images/logo.png","alt":"proton-logo"}})])])])])])
}]

export { render, staticRenderFns }